(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["member-signup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('member-signup')) {
    class MemberSignup extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        const success = this.querySelector('[data-ms-success]');
        if (success && !success.hidden) {
          this.#remember();
          this.#applyCode();
        } else if (!this.hasAttribute('data-design-mode') && this.#isMember()) {
          this.hidden = true;
          return;
        }

        this.form.addEventListener('submit', (event) => this.#onSubmit(event));
        this.querySelector('[data-ms-copy]')?.addEventListener('click', (event) => this.#copy(event));
      }

      async #onSubmit(event) {
        const input = this.form.querySelector('input[type="email"]');
        if (!input || !input.checkValidity() || !window.fetch) return;

        event.preventDefault();
        const button = this.form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;
        this.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(this.form.action, {
            method: 'POST',
            body: new FormData(this.form),
            headers: { Accept: 'text/html' },
          });

          if (response.url.includes('customer_posted=true')) {
            this.#showSuccess();
          } else if (response.url.includes('/challenge')) {
            HTMLFormElement.prototype.submit.call(this.form);
          } else {
            this.#showError(input);
          }
        } catch (error) {
          HTMLFormElement.prototype.submit.call(this.form);
        } finally {
          if (button) button.disabled = false;
          this.removeAttribute('aria-busy');
        }
      }

      #showSuccess() {
        this.querySelector('[data-ms-row]')?.setAttribute('hidden', '');
        this.querySelector('[data-ms-consent]')?.setAttribute('hidden', '');
        this.querySelector('[data-ms-error]')?.setAttribute('hidden', '');
        const success = this.querySelector('[data-ms-success]');
        if (success) {
          success.hidden = false;
          success.focus({ preventScroll: true });
        }
        this.#remember();
        this.#applyCode();
      }

      #showError(input) {
        const error = this.querySelector('[data-ms-error]');
        if (error) error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      }

      #applyCode() {
        const code = this.dataset.code;
        if (!code || this.dataset.autoApply !== 'true') return;
        fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' }).catch(() => {});
      }

      async #copy(event) {
        const button = event.currentTarget;
        try {
          await navigator.clipboard.writeText(this.dataset.code);
          const label = button.textContent;
          button.textContent = button.dataset.copiedLabel;
          setTimeout(() => (button.textContent = label), 2000);
        } catch (error) {
          const value = this.querySelector('.member-signup__code-value');
          if (value) window.getSelection()?.selectAllChildren(value);
        }
      }

      #remember() {
        try {
          localStorage.setItem('eco-member-signup', '1');
        } catch (error) {}
      }

      #isMember() {
        try {
          return localStorage.getItem('eco-member-signup') === '1';
        } catch (error) {
          return false;
        }
      }
    }

    customElements.define('member-signup', MemberSignup);
  }
  } catch(e) { console.error(e); }
})();

})();
